import isEmptyObject from '../../src/helpers/is-empty-object';
import { ALL, AMEX, DISCOVER, MASTERCARD } from '../constants/partnering-networks';
import collapsedLogger from '../helpers/collapsed-logger';

const formattedNetworkString = srcNetwork => {
  if (typeof srcNetwork === 'string' && srcNetwork !== '') {
    return srcNetwork.trim().toUpperCase();
  }
  return null;
};
/* To return a list of SRC networks based on BE response applicable when srcNetworksFut false
 * @param  {obj|Array} srcNetworks - supported srcNetworks from API response
 * @return {Array} srcSupportedNetworks - return formatted list of networks
*/
const getFormattedSRCNetworks = srcNetworks => {
  let srcSupportedNetworks = [];
  if (!isEmptyObject(srcNetworks) && srcNetworks) {
    const networkString = formattedNetworkString(srcNetworks.value);
    //Handle BE response 'ALL' when V-SRCi supports VISA, AMEX, DISCOVER, MASTERCARD sdks
    //VISA will be loaded by default
    if (networkString === ALL) {
      srcSupportedNetworks = [AMEX, DISCOVER, MASTERCARD];
    } else {
      const networksArray = networkString
        ? networkString.split(',')
        : Array.isArray(srcNetworks)
          ? srcNetworks
          : [];
      srcSupportedNetworks = networksArray.map(network => {
        return formattedNetworkString(network);
      });
    }
  }
  collapsedLogger('srcSupportedNetworks =>', srcSupportedNetworks);
  return srcSupportedNetworks;
};

export default getFormattedSRCNetworks;
